import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { api, ApiError } from '../../api';

export function NewCourse({ mode = 'admin' }: { mode?: 'admin' | 'instructor' }) {
  const base = mode === 'instructor' ? '/instructor/courses' : '/admin/courses';
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: '', code: '', traversal: 'sequential' });
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  return (
    <>
      <nav className="crumbs"><Link to={base}>Courses</Link> <span aria-hidden>›</span> New</nav>
      <h1 className="h1">New course</h1>

      <form className="panel form" onSubmit={async (e) => {
        e.preventDefault(); setBusy(true); setError(null);
        try {
          const r = await api.post<{ course: { id: number } }>('/admin/builder', {
            name: form.name.trim(), code: form.code.trim() || undefined, traversal: form.traversal,
          });
          navigate(`${base}/${r.course.id}/edit`);
        } catch (err) { setError((err as ApiError).message); }
        finally { setBusy(false); }
      }}>
        <label><span>Name</span>
          <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required autoFocus /></label>
        <label><span>Code</span>
          <input value={form.code} onChange={(e) => setForm({ ...form, code: e.target.value })} placeholder="optional" /></label>
        <label><span>Order</span>
          <select value={form.traversal} onChange={(e) => setForm({ ...form, traversal: e.target.value })}>
            <option value="sequential">In order — each unit unlocks the next</option>
            <option value="free">Any order</option>
          </select></label>

        <p className="muted small">It starts switched off. Add the content, then put it live.</p>
        {error && <p className="auth__error">{error}</p>}
        <div className="row">
          <button className="btn btn--primary" disabled={busy}>{busy ? 'Creating…' : 'Create'}</button>
          <Link className="btn btn--ghost" to={base}>Cancel</Link>
        </div>
      </form>
    </>
  );
}
